import { useEffect, type RefObject } from 'react';

/**
 * Radix treats a pointerdown or focus outside an open dialog as a dismissal and subscribes on `document`.
 * Stopping both at the control keeps an open modal from closing when the recorder or the launcher is used (EC13).
 * Runs after every render because the node mounts and unmounts with the recorder state.
 */
export function useShieldFromOutsideDismissal(ref: RefObject<HTMLElement | null>): void {
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const stop = (event: Event) => event.stopPropagation();
    node.addEventListener('pointerdown', stop);
    node.addEventListener('focusin', stop);
    return () => {
      node.removeEventListener('pointerdown', stop);
      node.removeEventListener('focusin', stop);
    };
  });
}
